import type { MemberRole } from './member'

export const SYSTEM_COMPANY_ID = 0

export type Membership = {
  company_id: number
  role: MemberRole
}

export type AccessContext = {
  memberships: Membership[]
  activeCompanyId: number | null
}

export function activeMembership(ctx: AccessContext): Membership | null {
  if (ctx.activeCompanyId == null) return null
  return ctx.memberships.find((m) => m.company_id === ctx.activeCompanyId) ?? null
}

export function isSystemContext(ctx: AccessContext): boolean {
  return ctx.activeCompanyId === SYSTEM_COMPANY_ID
}

export function isSystemAdmin(ctx: { memberships: Pick<Membership, 'company_id' | 'role'>[] }): boolean {
  return ctx.memberships.some((m) => m.company_id === SYSTEM_COMPANY_ID && m.role === 'admin')
}

export function isSystemMember(ctx: { memberships: Pick<Membership, 'company_id'>[] }): boolean {
  return ctx.memberships.some((m) => m.company_id === SYSTEM_COMPANY_ID)
}

export let canAccessUsersSection = isSystemContext
export let canAccessCompaniesSection = isSystemContext
export let canAccessStaffSection = (ctx: AccessContext) => !isSystemContext(ctx)
